<template>
  <div id="app">
    <router-view/>
    <!--<p v-if="isShowChromeTip" style="color: red;font-size: 15px; margin-top: 0px;text-align:center">-->
    <!--请务必使用Chrome浏览器打开【<a target="_blank"-->
    <!--href="https://www.baidu.com">点击下载</a>】-->
    <!--</p>-->
  </div>

</template>
<script>
export default {
  computed: {
    isShowChromeTip () {
      const USER_AGENT = navigator.userAgent.toLowerCase()
      const isChrome = /.*(chrome)\/([\w.]+).*/
      return !isChrome.test(USER_AGENT)
    }
  }
}
</script>
<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  #app {
    width: 100%;
    height: 100%;
    min-width: 1020px;
    margin: 0 auto;
  }

  html, body {
    width: 100%;
    height: 100%;
    background-color: #f0f2f5;
    -webkit-user-select: text;
  }

   .ivu-modal{
     top: 200px !important;
   }

  //添加tooltip文字向上移动问题
  .ivu-tooltip-rel{
    vertical-align: middle;
  }

  //input append 按钮点击范围
  .ivu-input-group-append{
    padding: 0  !important;
  }
  .ivu-input-group-append > span{
    padding: 6px 7px  !important;
  }
</style>
